<template>
  <main
    v-if="eventDetailsData && isEventAvailable(eventDetailsData)"
    class="event-details-page px-md-10 px-4 pt-16"
  >
    <v-snackbar color="red" :value="isError">
      {{ errorMessage }}
    </v-snackbar>

    <section class="my-6">
      <h1 class="headingTitle">{{ eventDetailsData.topic }}</h1>
    </section>
    <v-row>
      <v-col cols="12" class="col-md-8">
        <section>
          <div class="introFieldWrapper mt-9">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <div class="countField field">
                  <span class="label">{{
                    eventsData.eventFields.countLabel
                  }}</span>
                  <v-btn
                    class="secondary-btn"
                    outlined
                    style="border-color: #CECED8 !important"
                    v-bind="attrs"
                    v-on="on"
                    width="100%"
                    height="40"
                  >
                    {{ countField }}
                    <v-icon right large>mdi-chevron-down</v-icon>
                  </v-btn>
                </div>
              </template>
              <v-list>
                <v-list-item
                  v-for="(count, index) in maxPersonCount"
                  :key="index"
                  class="px-5"
                  style="cursor: pointer"
                  @click="countField = count"
                >
                  {{ count }}
                </v-list-item>
              </v-list>
            </v-menu>
            <InputField
              class="field"
              name="teamName"
              :placeholder="eventsData.eventFields.teamNameLabel"
              :label="eventsData.eventFields.teamNameLabel"
              v-model="teamNameField"
            />
          </div>
        </section>
        <div class="sectionWrapper">
          <section v-for="index in Number(countField)" :key="index">
            <div class="formWrapper">
              <h3 class="mb-9">{{ eventsData.personLabel }} {{ index }}</h3>
              <EventPersonForm
                @onSubmit="onFormSubmitHandler($event, index)"
                :is-disabled="isLoading"
                :is-already-saved="index in membersData"
                :initial-values="membersData[index]"
              />
            </div>
          </section>
        </div>
      </v-col>

      <v-col cols="12" class="col-md-4">
        <div class="pl-md-4">
          <div class="infoCard py-md-7 pa-4 px-md-8 mb-6">
            <h2 class="headingTitle">Lsaran {{ eventDetailsData.type }}</h2>
            <div class="infoDescriptionWrapper">
              <p
                v-if="eventDetailsData.info"
                class="infoDescription"
                v-html="eventDetailsData.info"
              />
              <p
                v-if="eventsData.teamInfo"
                class="infoDescription"
                v-html="eventsData.teamInfo"
              />
            </div>

            <div class="amountWrapper">
              <ul class="personList">
                <li
                  v-for="personIndex in Number(countField)"
                  :key="personIndex"
                  class="personListItem label"
                >
                  <PersonStatus :is-active="Boolean(membersData[personIndex])"
                    >{{ eventsData.personLabel }}
                    {{ personIndex }}</PersonStatus
                  >
                </li>
              </ul>

              <p
                class="donationLabel ma-0"
                v-if="isDonationAvailable && donation"
              >
                {{ eventsData.donationName }}:
                <span class="donationAmount">{{
                  donation | numberWithSpaces
                }}</span>
              </p>
            </div>

            <v-divider class="my-4" />

            <span class="amountLabel"
              >{{ eventsData.amountLabel }}: {{ amount }}
              {{ commonData.currency }}</span
            >

            <DonationField
              class="my-4"
              :checked="isDonationAvailable"
              :input="donation"
              @onCheckboxChange="onDonationCheckboxChangeHandler"
              @onInputChange="onDonationInputChangeHandler"
            />

            <v-btn
              :loading="isLoading"
              :disabled="!isRegisterAvailable"
              width="100%"
              height="40"
              class="main-btn mt-auto"
              @click="submitExtraActivity"
            >
              {{ eventsData.registerButtonName }}
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </main>
</template>

<script>
import InputField from "./InputField.vue";
import EventPersonForm from "./EventPersonForm.vue";
import PersonStatus from "./PersonStatus.vue";
import DonationField from "@/components/donation-filed/DonationField.vue";
import { getNumberWithSpaces } from "@/utils/getNumberWithSpaces";
import { postExtraActivity } from "@/api/extraActivity";

export default {
  name: "EventDetails",
  components: {
    DonationField,
    PersonStatus,
    EventPersonForm,
    InputField
  },
  filters: {
    numberWithSpaces(value) {
      return getNumberWithSpaces(value);
    }
  },
  computed: {
    amount() {
      let total = this.eventDetailsData.amountPerPerson * this.countField;

      const donationAmount = Number(this.donation);
      if (this.isDonationAvailable && !Number.isNaN(donationAmount)) {
        total += donationAmount;
      }

      return total;
    },

    isRegisterAvailable() {
      const isAllDataFilled = [...Array(this.countField).keys()].every(
        personItem => personItem + 1 in this.membersData
      );

      return isAllDataFilled;
    },

    commonData() {
      return this.$t("common");
    },

    eventsData() {
      return this.$t("events");
    },

    eventDetailsData() {
      const slug = this.$route.params.slug;
      const eventDetailsData = this.$t("events");

      if (slug && eventDetailsData.eventList) {
        return eventDetailsData.eventList.find(
          eventItem => eventItem.slug === slug
        );
      }

      return null;
    }
  },
  data() {
    return {
      requiredRules: [v => !!v || "Enter field"],
      maxPersonCount: 5,
      countField: 1,
      teamNameField: "",
      membersData: {},

      // donation
      isDonationAvailable: true,
      donation: 1000,

      // request
      isLoading: false,
      isError: false,
      errorMessage: ""
    };
  },
  methods: {
    onFormSubmitHandler(values, index) {
      this.$set(this.membersData, index, values);
    },

    async submitExtraActivity() {
      this.isLoading = true;
      this.isError = false;
      this.errorMessage = "";

      try {
        const members = [...Array(this.countField).keys()].map(personItem => {
          const filledData = this.membersData[personItem + 1];
          return {
            ...filledData,
            patronymic: ""
          };
        });

        const redirectUrl = `${window.location.origin}/events/${this.eventDetailsData.slug}/confirmation`;
        const lang = this.$i18n.locale ?? "en";
        const donationAmount = Number(this.donation);

        const data = {
          members,
          teamName: this.teamNameField ?? "",
          type: this.eventDetailsData.type,
          lang,
          redirectUrl
        };

        if (this.isDonationAvailable && !Number.isNaN(donationAmount)) {
          data.donation = donationAmount;
        }

        const response = await postExtraActivity(data);

        if ("redirectUrl" in response) {
          window.location.href = response.redirectUrl;
        } else {
          this.isError = true;
          this.errorMessage = "An error occurred, please try again later";
        }
      } catch (error) {
        console.log();
        this.isError = true;
        this.errorMessage =
          error.response?.data?.data?.error ??
          "An error occurred, please try again later";
      } finally {
        this.isLoading = false;
      }
    },

    // donation methods
    onDonationCheckboxChangeHandler(value) {
      this.isDonationAvailable = value;
    },

    onDonationInputChangeHandler(value) {
      this.donation = value;
    },

    isEventAvailable(event) {
      return new Date(event.date).getTime() > new Date().getTime();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/vars";
@import "src/assets/style/media";

.event-details-page {
  padding-bottom: 56px;
}

.headingTitle {
  font-family: "Roboto", sans-serif;
  font-size: 36px;
  line-height: 1.15;
  font-weight: 700;
  max-width: 60%;

  @include mobileMedia {
    max-width: 100%;
  }
}

.field {
  display: block;
  width: 232px;
}

.introFieldWrapper {
  display: flex;
  grid-gap: 20px;

  @include mobileMedia {
    flex-direction: column;
  }
}

.sectionWrapper {
  display: flex;
  flex-direction: column;
  grid-gap: 20px;
}

.formWrapper {
  border: 2px solid $second;
  padding: 20px;
}

.label {
  display: block;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  line-height: 1.15;
  font-weight: 700;
}

.countField {
  display: flex;
  flex-direction: column;
  grid-gap: 18px;
}

.infoCard {
  display: flex;
  flex-direction: column;
  background: $bgLight;
  min-height: 400px;
}

.infoDescriptionWrapper {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  margin-top: 12px;
}

.infoDescription {
  font-size: 16px;
  line-height: 1.2;
  font-weight: 500;
  margin: 0;
  color: $grey;
}

.amountWrapper {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
}

.personList {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  margin: 24px 0 0;
  padding: 0;
}

.donationLabel {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  line-height: 1.15;
  color: rgba($dark, 0.8);
  font-weight: 700;
}

.amountLabel {
  display: block;
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  line-height: 1.15;
  font-weight: 700;
  color: $activeColor;
}

.donationAmount {
  color: $activeColor;
}
</style>

<style lang="scss">
.introFieldWrapper .v-btn__content {
  justify-content: space-between;
  font-family: "Roboto", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
}
</style>
